import Chat from '../pages/Chat/Chat';
import Welcome from '../pages/Welcome/Welcome';
import FudaoHistory from '../pages/FudaoHistory/FudaoHistory';
import ChargeHistory from '../pages/ChargeHistory/ChargeHistory';
import IncomeHistory from '../pages/IncomeHistory/IncomeHistory';
import TeacherProfile from '../pages/TeacherProfile/TeacherProfile';
import WrongAnswerHistory from '../pages/WrongAnswerHistory/WrongAnswerHistory';

export default {
  'chat': Chat,
  'welcome': Welcome,
  'fudao-history': FudaoHistory,
  'charge-history': ChargeHistory,
  'income-history': IncomeHistory,
  'teacher-profile': TeacherProfile,
  'wrong-answer-history': WrongAnswerHistory
};